import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ConstructorCalloutCard = superstyled({
  name: 'ConstructorCallout',
  slot: 'Card',
  tag: Card,
  styles: ({ theme }) => ({
    borderColor: theme.palette.border.main, // TODO: remove after ZUI adds border color options.
    borderRadius: theme.shape.rounded.lg, // TODO: remove after ZUI adds border radius options.
    padding: 0 // Remove inherited padding (through CSS variables) when using nested cards components
  })
});

export const ConstructorCalloutContentContainer = superstyled({
  name: 'ConstructorCallout',
  slot: 'ContentContainer',
  tag: CardContent,
  propsAdded: {
    size: 'md'
  },
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    padding: theme.spacing(2)
  })
});

export const ConstructorCalloutContent = superstyled({
  name: 'ConstructorCallout',
  slot: 'Content',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(0.5),
    '&:not(:only-child):not(:last-child)': {
      marginBlockEnd: theme.spacing(0.5)
    }
  })
});

export const ConstructorCalloutBar = superstyled({
  name: 'ConstructorCallout',
  slot: 'Bar',
  tag: Box,
  propsNeeded: ['color'],
  styles: ({ color, theme }) => ({
    minWidth: 4,
    backgroundColor: theme.palette.background[color].main,
    borderRadius: theme.shape.rounded.full
  })
});

export const ConstructorCalloutDescription = superstyled({
  name: 'ConstructorCallout',
  slot: 'Description',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    component: 'p',
    size: 'sm',
    weight: 'regular'
  }
});

export const ConstructorCalloutTitle = superstyled({
  name: 'ConstructorCallout',
  slot: 'Title',
  tag: Heading,
  propsAdded: {
    component: 'h3',
    size: 'md',
    weight: 'medium'
  }
});

export const ConstructorCalloutButton = superstyled({
  name: 'ConstructorCallout',
  slot: 'Button',
  tag: Button,
  propsAdded: {
    color: 'info',
    size: 'sm',
    variant: 'outlined'
  }
});
